import './inProgress.css';
import * as React from 'react'
import {Component} from "react";


export class InProgress extends Component {
    render() {
        return(
            <div className={'in-progress'}>
                <div className={'in-progress-container'}>
                    <div className={'in-progress-img-container'}>
                        <img src={'resources/blonomLogo.png'}/>
                    </div>
                    <p>Nettsiden vår er under utvikling.</p>
                </div>
            </div>
        )
    }
}